import styled from 'styled-components'

import { Box } from '@ally/metronome-ui'

const StyledInputFieldSectionContainer = styled(Box)`
  ${({ theme: { space } }): string => `
    margin-bottom: ${space.md};
  `}
`

export default StyledInputFieldSectionContainer
